<template>
      <main class="main">
        <loading-container :loading="loading">
          <!--<div class="crumbs">
            <span>Туризм и отдых</span>
            <span>Сумки и рюкзаки</span>
            <span>{{item.name}}</span>
          </div>-->
          <div class="row mt-2 mb-5">
            <div class="col-12 col-md-8 p-0">
              <item-card :item="item"/>
  <!--            <suppliers class="mt-2"/>-->
              <tabs-info :item="item" class="mt-2"/>
              <item-reviews :item="item" class="mt-2"/>
            </div>
            <div class="col-12 col-md-4">
              <card-info :item="item"/>
            </div>
          </div>
        </loading-container>
      </main>
</template>

<script>
import CardInfo from "@/components/item/card-info";
import ItemCard from "@/components/item/item-card";
//import Suppliers from "@/components/item/suppliers";
import TabsInfo from "@/components/item/tabs-info";
import ItemReviews from "@/components/item/item-reviews";
import LoadingContainer from "@/components/loading-container";

export default {
name: "item",
  components: { TabsInfo, ItemCard, CardInfo, ItemReviews, LoadingContainer},
  data: ()=>({
    loading: true,
    item: []
  }),
  mounted() {
    this.getItem()
  },
  methods: {
    getItem() {
      if (localStorage.getItem('token')) {
        this.loading = true;
        this.$http.post('/get-item', {
          token: localStorage.getItem('token'),
          id: this.$route.params.id,
          provider: 1
        }).then(({data})=> {
          if (data.item) {
            this.item = data.item
            this.$root.$emit('changeHeaderTitle', this.item.name);
          }
        })
          .catch((error) => {
              console.log(error)
          })
          .finally(()=> this.loading = false)
      }
    },
  }
}
</script>

<style lang="scss">
  .crumbs{
    color: #7A818F;
    font-size: 11px;
    line-height: 13px;

    span:after {
      content: '●';
      color: #B6BCC8;
      line-height: 8px;
      font-size: 10px;
      margin: 0 8px;

    }

    span:last-child:after {
      content: '';
      margin: unset;
    }

  }
  .mcard {
    width: 100%;
    background-color: white;
    border-radius: 4px;
    border: 1px solid #EEF0F3;
  }
</style>